function loadNoticeImage(notice) {
  const image = notice.querySelector('.eu-guarantee-notice__image[data-src]');
  if (image) {
    image.src = image.dataset.src;
    image.removeAttribute('data-src');
  }
}

document.addEventListener(
  'toggle',
  (event) => {
    const notice = event.target;
    if (notice instanceof HTMLDetailsElement && notice.matches('.eu-guarantee-notice[open]')) {
      loadNoticeImage(notice);
    }
  },
  true
);

document.querySelectorAll('.eu-guarantee-notice[open]').forEach(loadNoticeImage);
